import { lazyNamed } from 'src/utils/lazyNamed';

export default {
  Helmet: lazyNamed(() => import('./components/Helmet'), 'Helmet'),
  Layout: lazyNamed(() => import('./components/Layout'), 'Layout'),
  AdMedia: lazyNamed(() => import('./containers/AdMedia'), 'AdMedia'),
  AdPrices: lazyNamed(() => import('./containers/AdPrices'), 'AdPrices'),
  AdPriceForm: lazyNamed(() => import('./containers/AdPriceForm'), 'AdPriceForm'),
  AdTypes: lazyNamed(() => import('./containers/AdTypes'), 'AdTypes'),
  Placements: lazyNamed(() => import('./containers/Placements'), 'Placements'),
  Products: lazyNamed(() => import('./containers/Products'), 'Products'),
  ProductForm: lazyNamed(() => import('./containers/ProductForm'), 'ProductForm'),
};
